// extracted by mini-css-extract-plugin
module.exports = {"a":"AppLink_a__QrBud"};